import {
  GetOperationHistory,
  PostOperationHistory,
} from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../../services/apiUtils';
import { formatQueryDateTime } from '../../_utils/utils';

const endPoint = 'operation-history';

export interface HistorySearchParam {
  rmaNo?: string;
  serialNo?: string;
  from?: string;
  to?: string;
  rowFrom: number;
  perPage: number;
}

export const getHistory = async (
  params: HistorySearchParam,
): Promise<GetOperationHistory> => {
  const queryParams = new URLSearchParams();

  if (params.rmaNo) {
    queryParams.append('rmaNo', params.rmaNo);
  }
  if (params.serialNo) {
    queryParams.append('serialNo', params.serialNo);
  }
  if (params.from) {
    queryParams.append('from', formatQueryDateTime(params.from, true));
  }
  if (params.to) {
    queryParams.append('to', formatQueryDateTime(params.to, false));
  }
  queryParams.append('rowFrom', params.rowFrom.toString());
  queryParams.append('perPage', params.perPage.toString());

  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const postHistory = async (
  data: PostOperationHistory,
): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'POST',
    body: JSON.stringify(data),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};
